import { render, staticRenderFns } from "./postjob.vue?vue&type=template&id=4f0662e4&scoped=true&"
import script from "./postjob.vue?vue&type=script&lang=js&"
export * from "./postjob.vue?vue&type=script&lang=js&"
import style0 from "./postjob.vue?vue&type=style&index=0&id=4f0662e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0662e4",
  null
  
)

export default component.exports